var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('navikey-toolbar'),_c('v-main',[_c('transition',[_c('keep-alive',[_c('router-view')],1)],1)],1),(false)?_c('v-footer',{attrs:{"color":"light-green darken-4","app":""}},[_c('span',{staticClass:"white--text"},[_vm._v("© 2021")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }